// extracted by mini-css-extract-plugin
export default {"cls1":"qRDR349LLMkesN8_0OOM","cls2":"PVwBfsdNmOkPX2ePziKP qRDR349LLMkesN8_0OOM"};